import type { BookingStepQueryTravelerPricesType } from '../../../common/types/queries/getBookingStepPageDataQuery/models';
import type {
  TransformedBookingStepTravelerNameType,
  TransformedBookingStepTravelerType,
  TransformedCartTravelerPriceType,
} from '../../../common/types/transformations/models';

export const getTotalPriceForTravelers = (
  travelerPrices: TransformedCartTravelerPriceType[] = [],
) => travelerPrices.reduce((total, { totalPriceSum }) => total + totalPriceSum, 0);

export const transformTravelerPrices = (
  travelers: TransformedBookingStepTravelerType[] = [],
  travelerPrices: BookingStepQueryTravelerPricesType = [],
  travelerNames: TransformedBookingStepTravelerNameType[] = [],
): TransformedCartTravelerPriceType[] =>
  Array.isArray(travelers)
    ? travelers.map((traveler, index) => {
        const {
          price,
          taxesAndFees = [],
          carrierPriceBreakdowns = [],
        } = travelerPrices?.find((travelerPrice) => travelerPrice?.travelerId === traveler?.id) ||
        {};

        const { fullName, firstName, lastName } =
          travelerNames.find((travelerName) => travelerName.travelerId === traveler?.id) || {};

        return {
          ageType: traveler?.ageType,
          firstName,
          fullName,
          lastName,
          markup: (price?.markup?.value as number) || null,
          carrierPriceBreakdowns,
          taxesAndFees,
          totalPrice: (price?.price?.value as number) ?? 0,
          totalPriceSum: (price?.price?.value as number) ?? 0,
          travelerId: traveler?.id || String(index),
          vat: (price?.vat?.value as number) || null,
        };
      })
    : [];

export const transformCartData = (
  travelers: TransformedBookingStepTravelerType[],
  travelerPrices: BookingStepQueryTravelerPricesType,
  travelerNames: TransformedBookingStepTravelerNameType[],
  voucherAmount: {
    value: number;
  },
) => {
  const discountAmount = voucherAmount?.value ?? 0;
  const transformedTravelerPrices = transformTravelerPrices(
    travelers,
    travelerPrices,
    travelerNames,
  );
  const totalTripPrice = getTotalPriceForTravelers(transformedTravelerPrices);

  return {
    discountAmount,
    travelerPrices: transformedTravelerPrices,
    totalTripPrice,
  };
};
